import { TUpdateWorkflowTemplateParams } from '@commenda/types';
import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';

export const updateWorkflowTemplate = async (
  workflowId: string,
  data: TUpdateWorkflowTemplateParams
): Promise<Response> => {
  const res = await fetcher(`${BASE_URL}/${workflowId}`, {
    method: 'POST',
    body: data,
  });
  return res;
};
